module.exports = __webpack_public_path__ + "static/media/search-mobile-icon.fa8a7e9b.svg";